export default __webpack_public_path__ + "static/media/bgplesk.20f99567.png";